import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";

class RentalRequestEndModal extends React.Component {
  render() {
    const {
      show,
      rental,
      isLoading,
      onClose,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const productName = rental.product_name || (rental.product ? rental.product.designation : "Produit");

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-request-end-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header style={{ backgroundColor: '#28a745', color: 'white', borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem' }}>
          <Modal.Title className="rental-modal-title">
            Demander la fin de la location
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <h5 className="rental-modal-product-name">
              Confirmer la demande
            </h5>
            <p className="rental-modal-form-hint">
              Voulez-vous demander la fin de la location pour <strong>{productName}</strong> ?
            </p>
            <p className="rental-modal-form-hint">
              Un administrateur validera votre demande.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rental-modal-btn-cancel"
            style={{ flex: 1 }}
          >
            Non
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              flex: 1,
              backgroundColor: isLoading ? '#1e7e34' : '#28a745',
              borderColor: '#28a745',
              color: 'white',
              padding: '0.5rem 1rem',
              borderRadius: '0.25rem',
              border: '1px solid',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.65 : 1
            }}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span> Envoi en cours...</span>
              </>
            ) : (
              "Oui"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalRequestEndModal;
